export default __webpack_public_path__ + "static/homebg-5e366a3a3c9f21ad410bff1181b70c15.jpg";